import { css } from '@emotion/react';
import { REACT_PRINT_STYLES, ScopeReportLineItem, ScopeReportLineItemWithChangeData } from '@kaiizen/kai-reports';
import { ScopeLineItemRow } from './ScopeLineItemRow';
import { useScopePrintPreviewContext } from './ScopePrintPreviewContext';
import { TradeHeader } from './TradeHeader';

const PAGE_SPACING_STYLE = css`
  margin-bottom: 40px;

  @media print {
    margin-bottom: 0;
  }
`;

export const TradePage = ({
  tradeName,
  items,
  groupRoomArea,
  groupTotal,
  startIndex = 0,
  isChangeOrderReport = false,
}: {
  tradeName: string;
  items: ScopeReportLineItem[];
  groupRoomArea?: number;
  groupTotal?: number;
  startIndex?: number;
  isChangeOrderReport?: boolean;
}) => {
  const { groupingMode, searchHighlightedTaskId, onLineItemClick } = useScopePrintPreviewContext();
  const groupNotes = items.length > 0 ? items[0].groupNotes : undefined;
  const groupId = items.length > 0 ? items[0].groupId : '';

  return (
    <div css={[REACT_PRINT_STYLES.page, PAGE_SPACING_STYLE]}>
      <TradeHeader
        tradeName={tradeName}
        groupRoomArea={groupRoomArea}
        groupTotal={groupTotal}
        groupNotes={groupNotes}
        groupId={groupId}
      />
      <table css={REACT_PRINT_STYLES.table}>
        <thead css={REACT_PRINT_STYLES.thead}>
          <tr>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '100px' }}>Status</th>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '120px' }}>Contractor</th>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '150px' }}>Task Description</th>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '150px' }}>Product</th>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '60px' }}>Qty</th>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '80px' }}>Rate</th>
            <th css={REACT_PRINT_STYLES.th} style={{ minWidth: '80px' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            const actualIndex = startIndex + index;
            const lineItemId = `${item.groupId}-${item.taskId}-${item.optionId}-${item.lineItemName}-${actualIndex}`;
            const itemWithChangeData = item as ScopeReportLineItemWithChangeData;

            const isFirstLineItemForTask = index === 0 || items[index - 1]?.taskId !== item.taskId;

            return (
              <ScopeLineItemRow
                key={index}
                lastItem={items[index - 1]}
                item={item}
                isSelected={searchHighlightedTaskId === item.taskId}
                lineItemId={lineItemId}
                changeOrderData={isChangeOrderReport ? itemWithChangeData.changeOrderData : undefined}
                showRowBanner={true}
                taskAnchorId={isFirstLineItemForTask ? `task-${item.taskId}` : undefined}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
